import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  redirectTo?: string;
  requiredRoles?: string | string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  redirectTo = '/',
  requiredRoles
}) => {
  const { user, loading } = useAuth();
  
  // Check for development auth token or SSO token from landing page
  const hasDevToken = localStorage.getItem('auth_token');
  const hasSSOToken = localStorage.getItem('firebaseToken');
  
  // Show loading spinner while Firebase initializes
  if (loading && !hasDevToken && !hasSSOToken) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  // Check if user is authenticated (Firebase, development token, or SSO token)
  if (!user && !hasDevToken && !hasSSOToken) {
    return <Navigate to={redirectTo} replace />;
  }
  
  // Role-based access control can be added later with custom claims
  // For now, all authenticated users can access protected routes
  
  // User is authenticated
  return <Outlet />;
};

export default PrivateRoute; 